import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import type { ShopMenuResponse } from './shop-menu.model';

/** Loads shop megamenu for this storefront channel only (via X-Channel-Code interceptor). */
@Injectable({
  providedIn: 'root',
})
export class ShopMenuService {
  private readonly http = inject(HttpClient);

  getShopMenu(): Observable<ShopMenuResponse> {
    return this.http.get<ShopMenuResponse>(`${environment.apiUrl}Storefront/GetShopMenu`);
  }
}
